module.exports = __webpack_public_path__ + "static/media/Decisions_Step3_Image3.bc7e0d12.jpg";